function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.4,12.889a11.489,11.489,0,0,1-2.855-1.346,13.438,13.438,0,0,1-2.5-2.106A15.842,15.842,0,0,1,0,6.681,15.846,15.846,0,0,1,2.05,3.926a13.438,13.438,0,0,1,2.5-2.106A11.489,11.489,0,0,1,7.4.474a10.546,10.546,0,0,1,6.249,0A11.489,11.489,0,0,1,16.506,1.82,13.436,13.436,0,0,1,19,3.926a15.842,15.842,0,0,1,2.05,2.755A15.846,15.846,0,0,1,19,9.436a13.436,13.436,0,0,1-2.5,2.106,11.489,11.489,0,0,1-2.855,1.346,10.546,10.546,0,0,1-6.249,0ZM3.231,6.681a8.809,8.809,0,0,0,14.591,0,8.809,8.809,0,0,0-14.591,0Zm4.715,0a2.573,2.573,0,0,1,2.475-2.662A2.573,2.573,0,0,1,12.9,6.681a2.573,2.573,0,0,1-2.475,2.662A2.573,2.573,0,0,1,7.946,6.681Z",
  fill: "#7e7e7e"
});

var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.053,
    height: 13.362,
    viewBox: "0 0 21.053 13.362",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-icon.9c22bf4c.svg";
export { ForwardRef as ReactComponent };